import { get, post, put, patch } from "../Config"

export function CreatePreview({ params = {}, data = {} }) {
  return post({ url: `/v1/admin/preview-data`, params, data })
}
